/* eslint-disable @typescript-eslint/camelcase */
import { all, takeEvery } from 'redux-saga/effects'
import * as questionActions from 'components/questions/actions'
import * as mainActions from 'components/main/actions'
import { ActionType, getType } from 'typesafe-actions'

type QuestionActions = ActionType<typeof questionActions>
function* answerQuestions() {
  yield takeEvery<QuestionActions>(
    '@questions/select',
    (action: QuestionActions) => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: `${action.type}:${action.payload.questionId}:${action.payload.clickedAnswer}`
      })
    }
  )
}

type SubmitActions = ActionType<typeof mainActions>
function* submitForm() {
  yield takeEvery<SubmitActions>(
    (action: SubmitActions) => action.type === getType(mainActions.submit),
    action => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: 'form_submit'
      })
    }
  )
}

export function* analyticsWatcher() {
  yield all([answerQuestions(), submitForm()])
}
